import { useEffect } from 'react';
import {
    getReferenceOptionsDocumentTypeByCountry,
    getReferenceOptionsTreatmentByCountry,
} from 'utilities/multiLanguageHelper';

export const useUserProfileInitialization = ({ userProfile, formActions }) => {
    useEffect(() => {
        formActions.change('userProfile.documentType', getReferenceOptionsDocumentTypeByCountry()[0].value);
        formActions.change('userProfile.treatment', getReferenceOptionsTreatmentByCountry()[0].value);
        const { jointHolderForm, jointHolderData, isJointHolderNoClient } = userProfile;
        if (jointHolderForm) {
            formActions.change('userProfile.jointHolderData', jointHolderData);
            formActions.change('userProfile.isJointHolder', true);
            formActions.change('userProfile.isJointHolderNoClient', isJointHolderNoClient);
            formActions.change('userProfile.jointHolderType', jointHolderData.invite.jointHolderType);
            formActions.change('userProfile.openDebitCard', jointHolderData.invite.openDebitCard);
            formActions.change('userProfile.isJointHolderAccount', true);
            formActions.change('userProfile.jointHolderDecision', 'false');
            const promoCodeValue = jointHolderData.invite.promoCode;
            if (promoCodeValue) {
                formActions.change('userProfile.promoCode', promoCodeValue);
            }
        }
    }, []);
};
